import * as tslib_1 from "tslib";
import { AfterViewInit, OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { RequestService } from '../../services/request/request-onboarding.service';
var OfficesSearchComponent = /** @class */ (function () {
    /**
     * Summary Initialize Services
     * @param abreCuentasService
     * @param parametersService
     * @param abreCuentasNavigationService
     * @param formBuilder
     */
    function OfficesSearchComponent(copyService, headerService, abreCuentasService, parametersService, navigationService, formBuilder, taggingService, biocatchService, requestService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.navigationService = navigationService;
        this.formBuilder = formBuilder;
        this.taggingService = taggingService;
        this.biocatchService = biocatchService;
        this.requestService = requestService;
        this.officeSelectEventEmiter = new EventEmitter();
        this.nextDisbursementOffice = new EventEmitter();
        /**
         * Oficinas de la ciudad
         *
         * *City offices*
         */
        this.offices = [];
        /**
         * Estado para mostrar el aviso de error
         *
         * *State to show error advice*
         */
        this.showEmptyOfficeError = false;
        /**
         * Lista de las oficinas
         *
         * *Agency list*
         */
        this.optionsData = [];
        /**
         * Existencia de las oficinas por ciudad
         *
         * *offices by city validation*
         */
        this.existOfficeByCity = false;
        this.existsOfficePreviousCity = false;
        /**
         * Oficinas filtradas
         *
         * *Filtered offices*
         */
        this.optionsOffice = [];
        /**
         * Oficinas filtradas
         *
         * *Filtered offices*
         */
        this.optionsOffice2 = [];
        /**
         * Oficinas filtradas de la ciudad seleccionada anteriormente
         *
         * *Filtered offices of the city previously selected*
         */
        this.optionsOfficePreviousCity = [];
        /**
         * Validacion para mostrar la oficinas
         *
         * *Validation to show offices list*
         */
        this.showOptionsOffice = true;
        /**
         * Oficina seleccionada
         *
         * *Selected office*
         */
        this.selectedOffice = {};
        this.subTitle = true;
        this.back = '';
        this.headerService.show(true, true, true);
        this.formGroup = this.formBuilder.group({});
        this.eventCategories = {
            warning: {
                module: 'body',
                type: 'warning',
                position: 'bottom',
            },
            TextField: {
                module: 'body',
                type: 'textField',
                position: 'center',
            },
        };
        this.district_option = this.abreCuentasService.getDistricts();
    }
    OfficesSearchComponent.prototype.ngOnChanges = function (changes) {
        if (changes.isDisbursementOffice && !changes.isDisbursementOffice.currentValue) {
            if (this.abreCuentasService.getAgencySelected() !== undefined) {
                this.selectedOffice = this.abreCuentasService.getAgencySelected();
            }
        }
        if (changes.isDisbursementOffice && changes.isDisbursementOffice.currentValue) {
            if (this.abreCuentasService.getDisbursementAgencySelected() !== undefined) {
                this.selectedOffice = this.abreCuentasService.getDisbursementAgencySelected();
            }
        }
    };
    /**
     * Summary initial event, customer information
     */
    OfficesSearchComponent.prototype.ngOnInit = function () {
        this.validateWithPurchase();
        this.previous();
        var product = this.abreCuentasService.getproductSelected().product_code;
        this.biocatchService.changeContext(StepBiocatchEnum.configuracion, product, false, true);
        this.contactInfo = this.abreCuentasService.getContactInfo();
        // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
        this.optionsData = this.parametersService.getSetting(OpEnum.AGENCY_LIST);
        this.reactiveErrorOffice = this.copyService.copies.city_offices_search_city_filter_office_not_found_message;
        // this.optionsFilter = this.options.map(option => ({ data: option, value: option.description }));
        this.showOptionsOffice = true;
        this.selectedCity = {
            city_code: '',
            country_code: '',
            province_code: 0,
            description: '',
        };
        if (this.abreCuentasService.getCitySearchSelected().description !== undefined) {
            this.selectedCity = this.abreCuentasService.getCitySearchSelected();
            this.selected_district = this.selectedCity.district_id;
            this.abreCuentasService.setCitySearchSelected(this.selectedCity);
            this.loadOffices();
            return;
        }
        if (this.abreCuentasService.getContactInfo().address !== undefined) {
            this.selectedCity = this.contactInfo.address.city;
            this.selected_district = this.selectedCity.district_id;
            this.abreCuentasService.setCitySearchSelected(this.selectedCity);
            this.loadOffices();
            return;
        }
        if (this.abreCuentasService.getCitySearchSelected().description !== null) {
            this.selectedCity = this.abreCuentasService.getCitySearchSelected();
            this.selected_district = this.selectedCity.district_id;
        }
    };
    /**
     * Summary Call after angular has fully started the component view, initialization of the form
     */
    OfficesSearchComponent.prototype.ngAfterViewInit = function () {
        this.formGroup = new FormGroup({
            'input-value-city': new FormControl('', [Validators.required]),
        });
        if (this.selectedCity.description === null && !this.showOptionsOffice && this.optionsOffice.length <= 0) {
            return;
        }
        this.formGroup = new FormGroup({
            'input-value-office': new FormControl('', [Validators.required]),
        });
    };
    /**
     * Load list of offices depending on a filter of the city,
     * optionOfficePrevious city and existsOfficePreviousCity validates if there are
     * offices in the city that was previously selected and it is used to validate if the
     * warning advice wil be shown
     *
     */
    OfficesSearchComponent.prototype.loadOffices = function () {
        var _this = this;
        this.optionsOffice = this.optionsData.filter(function (optionOffice) { return (optionOffice.city_code === _this.selectedCity.city_code
            && optionOffice.province_code.toString() === _this.selectedCity.province_code.toString()); });
        this.optionsOffice2 = this.optionsOffice;
        this.existOfficeByCity = this.optionsOffice2.length > 0;
        if (!this.existOfficeByCity) {
            var error = this.navigationService.camelize(this.reactiveErrorOffice);
            this.pageTagEvent('3', this.eventCategories.warning, 'show', error);
        }
        if (this.selectedPreviousCity === undefined) {
            return;
        }
        this.optionsOfficePreviousCity = this.optionsData.filter(function (optionOffice) { return (optionOffice.city_code === _this.selectedPreviousCity.city_code
            && optionOffice.province_code === _this.selectedPreviousCity.province_code); });
        this.existsOfficePreviousCity = this.optionsOfficePreviousCity.length > 0;
        if (!this.existsOfficePreviousCity) {
            this.showEmptyOfficeError = true;
        }
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    OfficesSearchComponent.prototype.selectOption = function (event) {
        if (event.value) {
            this.selectedPreviousCity = event.value;
            this.showEmptyOfficeError = false;
            this.selectedCity = this.options.find(function (e) { return e.city_code === event.value.city_code &&
                e.province_code === event.value.province_code; });
            this.abreCuentasService.setCitySearchSelected(this.selectedCity);
            this.loadOffices();
        }
        else {
            this.showOptionsOffice = true;
            this.selectedCity = {
                city_code: '0',
                province_code: 5,
                description: '',
                country_code: '',
            };
            this.loadOffices();
        }
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    OfficesSearchComponent.prototype.selectOptionOffice = function (event) {
        if (event.value) {
            this.selectedOffice = event.value;
            this.pageTagEvent('4', this.eventCategories.TextField, 'click', event.description);
            this.officeSelectEventEmiter.emit(event.value);
            if (this.selectedCity.province_code > 0 && this.selectedOffice.province_code > 0) {
                this.showOptionsOffice = false;
            }
        }
        else {
            this.showOptionsOffice = true;
            this.selectedOffice = {
                address: '',
                agency_code: '',
                city_code: '',
                country_code: '',
                description: '',
                province_code: 0,
            };
        }
    };
    OfficesSearchComponent.prototype.validateWithPurchase = function () {
        this.hasSavedLoan = (this.abreCuentasService.haveLoan &&
            this.abreCuentasService.getRequestLoanSelected().elementId === '02' &&
            this.abreCuentasService.getRequestEntity() !== 1 &&
            (!this.abreCuentasService.getFormLoan() || this.abreCuentasService.getDidBackAddLoan()));
    };
    OfficesSearchComponent.prototype.regularNavigation = function () {
        if (this.abreCuentasService.haveLoan && this.abreCuentasService.viewOptionMultiProduct) {
            this.navigationMultiLoan();
        }
        else if (this.abreCuentasService.getOfficeStatus()) {
            this.nextDisbursementOffice.emit();
        }
        else if (this.abreCuentasService.viewOptionMultiProduct) {
            this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
        }
        else {
            this.navigationService.nextStep();
        }
    };
    OfficesSearchComponent.prototype.navigationMultiLoan = function () {
        this.abreCuentasService.getPostlogin() ? this.abreCuentasService.setPassScreenCity(navCode[3]) : this.abreCuentasService.setPassScreenCity(navCode[1]);
        this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    };
    /**
     * Summary next event validation
     */
    OfficesSearchComponent.prototype.next = function () {
        if (this.abreCuentasService.haveLoan) {
            this.flowLoan();
        }
        else {
            this.regularNavigation();
        }
    };
    OfficesSearchComponent.prototype.flowLoan = function () {
        if (this.abreCuentasService.viewOptionMultiProduct && this.abreCuentasService.getPassScreenCity() === navCode[1]) {
            this.abreCuentasService.setPassScreenCity(navCode[2]);
            this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
        }
        else if (this.hasSavedLoan) {
            this.navigationService.nextStep(navCode[206]);
            this.abreCuentasService.getPostlogin() ? this.abreCuentasService.setPassScreenCity(navCode[0]) : this.abreCuentasService.setPassScreenCity(navCode[1]);
        }
        else {
            this.regularNavigation();
        }
    };
    /**
     * @author cramos
     * @param eventNumber id number of event 1/2/3/4
     * @param category object with properties see eventCategories variable
     * @param customAction action of event click/show
     * @param message  message of event click
     */
    OfficesSearchComponent.prototype.pageTagEvent = function (eventNumber, category, customAction, error) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionName"].path,
                    value: EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionName"].value,
                },
                {
                    path: EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E" + eventNumber + "setData"][tagPageName + "E" + eventNumber + "transactionDetailsProductcategory"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module[category.module],
                    type: EVENT.customCategory.type[category.type],
                    position: EVENT.customCategory.position[category.position],
                },
                action: EVENT.customAction[customAction],
                label: EVENT[tagPageName + "E" + eventNumber + "customLabel"],
                errorName: error,
            };
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log(error);
        }
    };
    OfficesSearchComponent.prototype.regularPrevious = function () {
        this.back = navCode[200];
        if (this.abreCuentasService.getOutlaySelection()) {
            switch (this.abreCuentasService.getOutlaySelection()) {
                case BUSINESS_CONST.ITAU:
                    this.back = navCode[202];
                    break;
                case BUSINESS_CONST.CHEQUE_ITAU:
                    if (this.abreCuentasService.getReceiveCard() === '1') {
                        this.back = navCode[202];
                    }
                    else {
                        this.back = navCode[201];
                    }
                    break;
                default:
                    this.back = navCode[201];
                    break;
            }
        }
    };
    /**
     * metodo para volver
     */
    OfficesSearchComponent.prototype.previous = function () {
        if (this.abreCuentasService.getFormLoan() &&
            !this.abreCuentasService.getDidBackAddLoan()) {
            this.back = navCode[201];
        }
        else {
            this.regularPrevious();
        }
    };
    OfficesSearchComponent.prototype.getCitys = function (provence_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.cityBranches(provence_id).then(function (response) {
                            _this.city_option = response.body;
                            var cityReturn = _this.city_option.map(function (data) {
                                var codeDane = data.code_dane;
                                var codeDanelength = codeDane.length - 3;
                                return {
                                    city_code: codeDane.substring(codeDanelength),
                                    province_code: +codeDane.substring(0, codeDanelength),
                                    description: data.city,
                                    district_id: data.district.district_id,
                                };
                            });
                            _this.options = cityReturn.filter(function (x) { return _this.optionsData.map(function (y) { return y.city_code + y.province_code.toString(); }).includes(x.city_code + x.province_code.toString()); });
                            if (_this.options.length === 0) {
                                _this.city_option = undefined;
                                _this.showEmptyOfficeError = true;
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OfficesSearchComponent.prototype.selectOptionProvidence = function (event) {
        var value = event.value;
        console.log(event);
        if (value && value.trim() !== '') {
            this.selected_district = value;
            this.getCitys(value);
        }
        else {
            this.showOptionsOffice = true;
            this.city_option = undefined;
            this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
            this.selected_district = undefined;
            this.loadOffices();
            this.showEmptyOfficeError = false;
            this.existOfficeByCity = true;
        }
    };
    return OfficesSearchComponent;
}());
export { OfficesSearchComponent };
